import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import imageIcon from '../theme/icons/save.svg';
const SAVE = 'save';
export default class SaveUI extends Plugin {
    /**
	 * @inheritDoc
	 */
    init() {
        const editor = this.editor;
        const t = editor.t;
        // Add bold button to feature components.
        editor.ui.componentFactory.add(SAVE, locale => {
            const command = editor.commands.get(SAVE);
            const view = new ButtonView(locale);
            view.set({
                label: t('f'),
                icon: imageIcon,
                keystroke: 'CTRL+S',
                tooltip: true
            });
            //view.bind( 'isOn', 'isEnabled' ).to( command, 'value', 'isEnabled' );
            // Execute command.
            this.listenTo(view, 'execute', () => editor.execute(SAVE));
            return view;
        });
    }
}